/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `UNDERSTAFFED` - Understaffed
 * * `HIGH_DEMAND` - High Demand
 * * `PERSONAL_CHOICE` - Personal Choice
 * * `NOT_OFFERED` - Not Offered
 * * `LATE_BREAK` - Late Break
 * * `EDIT_BREAK_TIME` - Edit Break Time
 * * `FORGOT_TO_TRACK` - Forgot To Track
 * * `OTHER` - Other
 */
export type SkippedBreakReasonEnum = typeof SkippedBreakReasonEnum[keyof typeof SkippedBreakReasonEnum];


export const SkippedBreakReasonEnum = {
  UNDERSTAFFED: 'UNDERSTAFFED',
  HIGH_DEMAND: 'HIGH_DEMAND',
  PERSONAL_CHOICE: 'PERSONAL_CHOICE',
  NOT_OFFERED: 'NOT_OFFERED',
  LATE_BREAK: 'LATE_BREAK',
  EDIT_BREAK_TIME: 'EDIT_BREAK_TIME',
  FORGOT_TO_TRACK: 'FORGOT_TO_TRACK',
  OTHER: 'OTHER',
} as const;
